// Crypto (USDT & co.) recharge configuration.
//
// Crypto orders are settled through the Cregis payment engine
// (https://developers.cregis.com/zh/reference/waas-api/). Cregis requests are
// signed with the project API key and only accepted from the whitelisted server
// IP, so the checkout is always created by Dana
// (`/payment/external/order/cregis/create`), never from this page.
//
// The channel, the coin packs and the token list all come from the API; what
// lives here is display and validation only. See docs/crypto-recharge.md.

export const CRYPTO_CHANNEL_CODE = 'cregis'

// Crypto is priced in USD regardless of the selected country / fiat currency.
export const CRYPTO_CURRENCY = 'USD'

// "Global" is a page-only region for players who pay in crypto wherever they are. The API has no
// such country (it falls back to its default), so the page asks for the default country's
// channels and keeps only the crypto one. Crypto orders do not use the country.
export const GLOBAL_REGION = Object.freeze({ code: 'GLOBAL', name: 'Global' })

export function isGlobalRegion(code) {
  return code === GLOBAL_REGION.code
}

// Minutes a Cregis checkout stays payable, mirroring `cregis.valid-minutes`.
export const CREGIS_VALID_MINUTES = 60

// Labels for the Cregis token identifiers the API offers as payment methods.
const TOKEN_LABELS = {
  'USDT-TRC20': 'USDT · TRON',
  'USDT-ERC20': 'USDT · Ethereum',
  'USDT-BEP20': 'USDT · BNB Chain',
  'USDT-Polygon': 'USDT · Polygon',
  'USDT-Solana': 'USDT · Solana',
  'USDC-ERC20': 'USDC · Ethereum',
  'USDC-Polygon': 'USDC · Polygon',
  'USDC-Solana': 'USDC · Solana',
  BTC: 'BTC',
  ETH: 'ETH',
  TRX: 'TRX',
  SOL: 'SOL',
  BNB: 'BNB'
}

export function cryptoTokenLabel(code) {
  return TOKEN_LABELS[code] || code
}

export function isCryptoChannel(code) {
  return code === CRYPTO_CHANNEL_CODE
}
